const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M61.0002 99.2188C84.0331 99.2188 102.705 91.894 102.705 82.8584C102.705 73.8227 84.0331 66.4979 61.0002 66.4979C37.9673 66.4979 19.2954 73.8227 19.2954 82.8584C19.2954 91.894 37.9673 99.2188 61.0002 99.2188Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9667 72.5731C33.7182 72.1698 33.1896 72.0444 32.7852 72.2929L32.0543 72.7437L31.6036 72.0128C31.355 71.6095 30.8264 71.4841 30.422 71.7326C30.0187 71.9812 29.8933 72.5098 30.1418 72.9142L30.5925 73.6451L31.494 75.1068L32.9557 74.2054L33.6866 73.7547C34.0899 73.505 34.2153 72.9764 33.9667 72.5731Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7065 43.7742H32.4814L35.9494 42.2504L35.7065 43.7742Z",
    fill: "#3567B6",
    style: {
      fill: "#3567B6",
      fill: "color(display-p3 0.2078 0.4039 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7067 44.0284H32.4816C32.3618 44.0284 32.2579 43.9437 32.233 43.8262C32.2082 43.7088 32.2692 43.5902 32.3799 43.5416L35.8479 42.0188C35.9326 41.9816 36.032 41.994 36.1054 42.0505C36.1788 42.1069 36.2161 42.1996 36.2014 42.2922L35.9586 43.8149C35.9371 43.9369 35.8309 44.0284 35.7067 44.0284ZM33.6914 43.5201H35.4886L35.6242 42.6718L33.6914 43.5201Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0706 24.9128L76.3302 42.1002L76.0624 43.7743L75.7314 45.8505L77.0294 45.0925L78.743 47.4286L79.0096 45.7545L81.7512 28.5672L79.0706 24.9128Z",
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8510 0.8980 0.9725)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7432 47.6828C78.663 47.6828 78.5873 47.6455 78.5388 47.5789L76.9607 45.4269L75.8604 46.0697C75.7757 46.1194 75.6695 46.116 75.5882 46.0595C75.5068 46.0031 75.465 45.907 75.4808 45.8099L78.82 24.8722C78.8358 24.7705 78.9115 24.6892 79.0109 24.6655C79.1103 24.6418 79.2154 24.679 79.2753 24.7626L81.9559 28.417C81.9965 28.4712 82.0124 28.5401 82.0022 28.6079L78.994 47.4693C78.9782 47.571 78.9025 47.6523 78.8031 47.676C78.7827 47.6806 78.7635 47.6828 78.7432 47.6828ZM77.0296 44.8384C77.1086 44.8384 77.1855 44.8746 77.2352 44.9423L78.5885 46.7881L81.4837 28.6327L79.2256 25.5545L76.0671 45.3603L76.9008 44.8723C76.9415 44.8497 76.9855 44.8384 77.0296 44.8384Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.479 43.7743H35.7064L35.3742 45.8539L32.479 43.7743Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3743 46.1081C35.3223 46.1081 35.2704 46.0923 35.2263 46.0607L32.3311 43.981C32.2418 43.9166 32.2034 43.8014 32.2373 43.6964C32.2712 43.5913 32.3683 43.5201 32.479 43.5201H35.7053C35.7798 43.5201 35.8499 43.5529 35.8984 43.6094C35.947 43.6659 35.9673 43.7404 35.956 43.8138L35.6239 45.8935C35.6104 45.9805 35.5516 46.0539 35.4703 46.0878C35.4409 46.1013 35.407 46.1081 35.3743 46.1081ZM33.2687 44.0285L35.1879 45.4066L35.4082 44.0285H33.2687Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0708 24.9128L76.3304 42.1002L76.0626 43.7743L75.7317 45.8505L58.3399 56.0161H51.1667L50.9973 57.0779L35.3745 45.8539L35.7066 43.7743L35.9495 42.2504L37.0554 35.3111H47.6513L49.2814 25.0891L49.4938 24.9128H79.0708Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4289 60.6396L48.3074 73.9422H27.668L42.7485 65.1288L50.4289 60.6396Z",
    fill: "#5F92E1",
    style: {
      fill: "#5F92E1",
      fill: "color(display-p3 0.3725 0.5725 0.8824)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3074 73.9421L50.988 77.5965H30.3486L27.668 73.9421H48.3074Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4897 77.8507H30.2199L27.1665 73.688H48.4363L51.4897 77.8507ZM30.4774 77.3423H50.4866L48.1787 74.1963H28.1696L30.4774 77.3423Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2856 43.7743L81.9663 47.4286L80.0131 59.6704L77.3325 56.0161L79.2856 43.7743Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.013 59.9246C79.9328 59.9246 79.8571 59.8874 79.8085 59.8207L77.1279 56.1664C77.0873 56.1121 77.0714 56.0432 77.0816 55.9754L79.0336 43.7336C79.0494 43.632 79.1251 43.5507 79.2245 43.5269C79.3239 43.5032 79.429 43.5405 79.4888 43.6241L82.1695 47.2784C82.2101 47.3326 82.2259 47.4016 82.2158 47.4693L80.2638 59.7111C80.248 59.8128 80.1723 59.8941 80.0729 59.9179C80.0537 59.9224 80.0333 59.9246 80.013 59.9246ZM77.6001 55.9517L79.8582 59.03L81.6984 47.4942L79.4403 44.4159L77.6001 55.9517Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6023 56.016L93.2829 59.6703L89.3427 84.3731L86.6621 80.7187L90.6023 56.016Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3426 84.6273C89.2624 84.6273 89.1867 84.59 89.1381 84.5233L86.4575 80.869C86.4168 80.8148 86.401 80.7459 86.4112 80.6781L90.3513 55.9753C90.3672 55.8737 90.4428 55.7923 90.5423 55.7686C90.6417 55.7449 90.7467 55.7822 90.8066 55.8658L93.4872 59.5201C93.5279 59.5744 93.5437 59.6433 93.5335 59.711L89.5934 84.4138C89.5775 84.5154 89.5019 84.5968 89.4025 84.6205C89.3832 84.625 89.3629 84.6273 89.3426 84.6273ZM86.9297 80.6544L89.1878 83.7326L93.015 59.7359L90.7569 56.6576L86.9297 80.6544Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1985 80.7188L79.0449 81.6812L78.0361 88.0049L80.7167 91.6603L81.7255 85.3355L81.8791 84.3731L79.1985 80.7188Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7166 91.9145C80.6364 91.9145 80.5607 91.8773 80.5121 91.8106L77.8315 88.1551C77.7909 88.1009 77.7751 88.032 77.7852 87.9642L78.9476 80.6781C78.9634 80.5764 79.0391 80.4951 79.1385 80.4714C79.2379 80.4477 79.343 80.4849 79.4028 80.5685L82.0835 84.2229C82.1241 84.2771 82.1399 84.346 82.1298 84.4138L80.9674 91.6999C80.9516 91.8016 80.8759 91.8829 80.7765 91.9066C80.7561 91.9123 80.7369 91.9145 80.7166 91.9145ZM78.3037 87.9405L80.5618 91.0187L81.6113 84.4386L79.3531 81.3604L78.3037 87.9405Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6445 80.7188L72.4895 81.6812L78.036 88.0049L79.0447 81.6812L79.1984 80.7188H71.6445Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0359 88.259C77.9636 88.259 77.8936 88.2285 77.845 88.1721L71.4536 80.8859C71.3881 80.8114 71.3722 80.7041 71.4129 80.6137C71.4536 80.5233 71.5451 80.4646 71.6445 80.4646H79.1972C79.2717 80.4646 79.3418 80.4974 79.3904 80.5538C79.4389 80.6103 79.4593 80.6849 79.448 80.7583L78.2856 88.0444C78.2698 88.1416 78.1997 88.2218 78.1048 88.2489C78.0834 88.2568 78.0597 88.259 78.0359 88.259ZM72.2059 80.9729L77.8699 87.431L78.9001 80.9729H72.2059Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4791 43.7743L35.3743 45.8539L50.9971 57.0779L50.4289 60.6397L42.7485 65.1288L27.668 73.9422L32.4791 43.7743Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6681 74.1963C27.6184 74.1963 27.5676 74.1816 27.5247 74.1523C27.4433 74.0969 27.4016 73.9998 27.4174 73.9026L32.2285 43.7347C32.242 43.6477 32.3008 43.5743 32.3821 43.5404C32.4634 43.5065 32.5561 43.5167 32.6283 43.5687L51.1464 56.8723C51.2243 56.9288 51.2638 57.0237 51.2492 57.1186L50.681 60.6803C50.6685 60.756 50.6245 60.8215 50.5578 60.8599L27.7969 74.1613C27.7563 74.185 27.7122 74.1963 27.6681 74.1963ZM32.6656 44.2205L28.0036 73.4519L50.1975 60.4804L50.7216 57.192L32.6656 44.2205Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2854 43.7743L77.3323 56.0161H58.3398L79.2854 43.7743Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3321 56.2703H58.3397C58.2244 56.2703 58.1239 56.1935 58.0945 56.0828C58.0652 55.9721 58.1126 55.8546 58.212 55.797L79.1576 43.5552C79.2423 43.5055 79.3485 43.5088 79.4299 43.5653C79.5112 43.6207 79.553 43.7178 79.5372 43.815L77.5829 56.0556C77.5637 56.1799 77.4575 56.2703 77.3321 56.2703ZM59.2784 55.7619H77.1152L78.9486 44.2646L59.2784 55.7619Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3323 56.0161H90.6021L86.6619 80.7189H79.1985H71.6458H47.2266L48.3076 73.9422L50.4291 60.6397L50.9973 57.078L51.1667 56.0161H58.3399H77.3323ZM80.1044 70.4155C80.4648 70.4155 80.8003 70.1354 80.8556 69.7897C80.911 69.4429 80.6647 69.1616 80.3044 69.1616H56.9482C56.5901 69.1616 56.2534 69.4429 56.1981 69.7897C56.1427 70.1354 56.389 70.4155 56.7471 70.4155H80.1044ZM80.9968 64.8171C81.3572 64.8171 81.6927 64.5358 81.748 64.189C81.8034 63.8433 81.5571 63.5632 81.1968 63.5632H57.8417C57.4836 63.5632 57.147 63.8444 57.0927 64.189C57.0374 64.5358 57.2837 64.8171 57.6417 64.8171H80.9968ZM79.2109 76.0139C79.5712 76.0139 79.9067 75.7338 79.9621 75.3859C80.0174 75.0402 79.7712 74.7589 79.4108 74.7589H65.8383C65.478 74.7589 65.1425 75.0402 65.0871 75.3859C65.0318 75.7327 65.278 76.0139 65.6384 76.0139H79.2109Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6618 80.973H47.2265C47.1519 80.973 47.0819 80.9403 47.0333 80.8838C46.9847 80.8273 46.9644 80.7528 46.9757 80.6793L50.9159 55.9766C50.9351 55.8535 51.0424 55.762 51.1666 55.762H90.602C90.6765 55.762 90.7466 55.7947 90.7952 55.8512C90.8437 55.9077 90.8641 55.9822 90.8528 56.0557L86.9126 80.7584C86.8934 80.8827 86.7872 80.973 86.6618 80.973ZM47.5247 80.4647H86.445L90.3038 56.2703H51.3835L47.5247 80.4647ZM79.2108 76.2681H65.6372C65.3887 76.2681 65.1593 76.1665 65.008 75.9902C64.8589 75.8151 64.7967 75.5858 64.8351 75.3464C64.9108 74.8753 65.3503 74.5059 65.8371 74.5059H79.4108C79.6593 74.5059 79.8886 74.6076 80.04 74.7838C80.1891 74.9589 80.2512 75.1871 80.2128 75.4254C80.1382 75.8987 79.6977 76.2681 79.2108 76.2681ZM65.8383 75.0142C65.6033 75.0142 65.374 75.2029 65.339 75.4266C65.3243 75.5181 65.3446 75.5994 65.3966 75.6604C65.4519 75.7248 65.5378 75.7598 65.6383 75.7598H79.2119C79.4469 75.7598 79.6762 75.57 79.7124 75.3464C79.7271 75.256 79.7067 75.1746 79.6548 75.1136C79.5994 75.0493 79.5135 75.0131 79.4119 75.0131H65.8383V75.0142ZM80.1043 70.6697H56.7481C56.4996 70.6697 56.2714 70.568 56.1201 70.3918C55.9709 70.2167 55.9088 69.9885 55.9472 69.749C56.0229 69.2769 56.4623 68.9075 56.9481 68.9075H80.3043C80.5528 68.9075 80.7821 69.0091 80.9335 69.1854C81.0826 69.3604 81.1447 69.5898 81.1063 69.8292C81.0306 70.3003 80.5912 70.6697 80.1043 70.6697ZM56.9481 69.4158C56.7131 69.4158 56.4849 69.6056 56.4499 69.8292C56.4352 69.9185 56.4556 70.0021 56.5075 70.0619C56.5629 70.1263 56.6476 70.1613 56.7481 70.1613H80.1043C80.3393 70.1613 80.5686 69.9727 80.6036 69.749C80.6183 69.6575 80.598 69.5762 80.546 69.5152C80.4907 69.4508 80.4048 69.4158 80.3043 69.4158H56.9481ZM80.9968 65.0712H57.6405C57.392 65.0712 57.1638 64.9696 57.0136 64.7934C56.8633 64.6183 56.8023 64.3889 56.8408 64.1495C56.9164 63.6784 57.3559 63.309 57.8416 63.309H81.1978C81.4463 63.309 81.6757 63.4107 81.827 63.5869C81.9761 63.762 82.0383 63.9902 81.9999 64.2285C81.9242 64.7019 81.4836 65.0712 80.9968 65.0712ZM57.8416 63.8174C57.6066 63.8174 57.3785 64.006 57.3434 64.2297C57.3288 64.32 57.3491 64.4036 57.4011 64.4635C57.4553 64.5279 57.5411 64.5629 57.6417 64.5629H80.9979C81.2328 64.5629 81.4622 64.3731 81.4983 64.1495C81.513 64.0591 81.4927 63.9778 81.4407 63.9179C81.3853 63.8535 81.2995 63.8174 81.1978 63.8174H57.8416Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1964 63.5631C81.5568 63.5631 81.803 63.8444 81.7477 64.1889C81.6923 64.5357 81.3568 64.817 80.9965 64.817H57.6403C57.2822 64.817 57.0359 64.5357 57.0913 64.1889C57.1466 63.8433 57.4821 63.5631 57.8402 63.5631H81.1964Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9965 65.0769H57.6402C57.3906 65.0769 57.1602 64.9752 57.0088 64.7967C56.8585 64.6205 56.7964 64.39 56.8348 64.1483C56.9105 63.675 57.3522 63.3033 57.8402 63.3033H81.1964C81.4472 63.3033 81.6776 63.405 81.8301 63.5835C81.9804 63.7597 82.0425 63.989 82.0041 64.2296C81.9284 64.7052 81.4856 65.0769 80.9965 65.0769ZM57.8413 63.823C57.6097 63.823 57.3838 64.0094 57.3477 64.2308C57.333 64.3211 57.3533 64.4002 57.4042 64.4601C57.4584 64.5233 57.542 64.5572 57.6414 64.5572H80.9976C81.2303 64.5572 81.4574 64.3697 81.4924 64.1483C81.5071 64.0591 81.4867 63.98 81.4359 63.9201C81.3817 63.8569 81.297 63.8218 81.1975 63.8218H57.8413V63.823Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3043 69.1615C80.6647 69.1615 80.911 69.4428 80.8556 69.7896C80.8003 70.1352 80.4648 70.4154 80.1044 70.4154H56.7482C56.3901 70.4154 56.1438 70.1341 56.1992 69.7896C56.2545 69.4428 56.59 69.1615 56.9493 69.1615H80.3043Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1044 70.6741H56.7482C56.4985 70.6741 56.2681 70.5725 56.1167 70.394C55.9665 70.2177 55.9043 69.9873 55.9427 69.7478C56.0184 69.2734 56.4601 68.9017 56.9481 68.9017H80.3043C80.5551 68.9017 80.7855 69.0034 80.9369 69.1819C81.0872 69.3581 81.1493 69.5885 81.1109 69.8303C81.0352 70.3036 80.5935 70.6741 80.1044 70.6741ZM56.9481 69.4202C56.7165 69.4202 56.4906 69.6077 56.4545 69.8292C56.4398 69.9184 56.4601 69.9975 56.5109 70.0573C56.5652 70.1206 56.6487 70.1556 56.7482 70.1556H80.1044C80.3371 70.1556 80.5641 69.9692 80.5992 69.7478C80.6138 69.6575 80.5935 69.5784 80.5427 69.5185C80.4885 69.4552 80.4037 69.4202 80.3043 69.4202H56.9481Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4107 74.76C79.7711 74.76 80.0173 75.0413 79.962 75.3858C79.9066 75.7326 79.5711 76.0139 79.2108 76.0139H65.6372C65.2768 76.0139 65.0305 75.7326 65.0859 75.3858C65.1412 75.0402 65.4767 74.76 65.8371 74.76H79.4107Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2106 76.2738H65.637C65.3862 76.2738 65.1558 76.1721 65.0044 75.9936C64.8542 75.8174 64.792 75.5869 64.8304 75.3452C64.9061 74.8719 65.3478 74.5002 65.8369 74.5002H79.4106C79.6613 74.5002 79.8918 74.6019 80.0443 74.7804C80.1945 74.9566 80.2567 75.1859 80.2182 75.4265C80.1426 75.9021 79.6997 76.2738 79.2106 76.2738ZM65.8381 75.0199C65.6054 75.0199 65.3783 75.2063 65.3433 75.4277C65.3286 75.518 65.3489 75.5971 65.3998 75.657C65.454 75.7202 65.5387 75.7553 65.6381 75.7553H79.2117C79.4444 75.7553 79.6715 75.5677 79.7065 75.3463C79.7212 75.2571 79.7009 75.178 79.65 75.1181C79.5958 75.0549 79.5111 75.0199 79.4117 75.0199H65.8381Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6446 80.7188L74.3253 84.3731H49.9072L47.2266 80.7188H71.6446Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3251 84.6273H49.907C49.8257 84.6273 49.75 84.5889 49.7026 84.5234L47.022 80.869C46.9655 80.7922 46.9564 80.6894 47.0005 80.6035C47.0434 80.5177 47.1315 80.4646 47.2275 80.4646H71.6456C71.727 80.4646 71.8026 80.503 71.8501 80.5685L74.5307 84.2229C74.5872 84.2997 74.5962 84.4025 74.5522 84.4883C74.5092 84.5742 74.4211 84.6273 74.3251 84.6273ZM50.0358 84.1189H73.8235L71.5157 80.9729H47.7291L50.0358 84.1189Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.036 88.0049L72.4895 81.6812L71.6445 80.7188L74.3251 84.3731L75.169 85.3355L80.7166 91.6603L78.036 88.0049Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7166 91.9145C80.6454 91.9145 80.5754 91.8851 80.5257 91.8275L74.1342 84.5414C74.1297 84.5358 74.1252 84.5301 74.1207 84.5245L71.4401 80.8701C71.3599 80.7606 71.3802 80.6069 71.4864 80.5211C71.5926 80.4364 71.7473 80.4499 71.8366 80.5516L78.228 87.8377C78.2325 87.8433 78.2371 87.849 78.2416 87.8546L80.9222 91.509C81.0024 91.6186 80.9821 91.7722 80.8759 91.858C80.8284 91.8953 80.7731 91.9145 80.7166 91.9145Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6617 80.7188L89.3423 84.3731H81.8789L79.1982 80.7188H86.6617Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3422 84.6273H81.8787C81.7974 84.6273 81.7217 84.5889 81.6742 84.5234L78.9936 80.869C78.9372 80.7922 78.9281 80.6894 78.9722 80.6035C79.0151 80.5177 79.1032 80.4646 79.1992 80.4646H86.6627C86.744 80.4646 86.8197 80.503 86.8672 80.5685L89.5478 84.2229C89.6042 84.2997 89.6133 84.4025 89.5692 84.4883C89.5263 84.5742 89.4382 84.6273 89.3422 84.6273ZM82.0075 84.1189H88.8406L86.5328 80.9729H79.6997L82.0075 84.1189Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9972 57.3321C50.9452 57.3321 50.8933 57.3163 50.8492 57.2846L35.2264 46.0606C35.1485 46.0041 35.1089 45.9093 35.1236 45.8144L36.8045 35.2727C36.8147 35.2117 36.8452 35.1574 36.8926 35.1179L49.1186 24.8959L49.3321 24.7185C49.3773 24.6801 49.4349 24.6598 49.4948 24.6598H79.0719C79.1464 24.6598 79.2165 24.6925 79.265 24.749C79.3136 24.8055 79.3339 24.8801 79.3226 24.9535L75.9835 45.8912C75.971 45.9669 75.927 46.0324 75.8603 46.0708L58.4686 56.2363C58.4301 56.2589 58.385 56.2713 58.3398 56.2713H51.3835L51.248 57.1186C51.2344 57.2056 51.1757 57.279 51.0943 57.3129C51.0638 57.3253 51.0311 57.3321 50.9972 57.3321ZM35.65 45.7387L50.8108 56.6317L50.9147 55.9765C50.9339 55.8534 51.0412 55.7619 51.1655 55.7619H58.2697L75.4988 45.6912L78.7725 25.1659H49.5863L49.4439 25.2833L37.2914 35.4432L35.65 45.7387Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2812 25.089L47.6511 35.311H37.0552L49.2812 25.089Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6511 35.5652H37.0551C36.9478 35.5652 36.8529 35.4986 36.8168 35.398C36.7806 35.2975 36.8111 35.1845 36.8925 35.1167L49.1185 24.8947C49.1998 24.827 49.315 24.8168 49.4065 24.8687C49.4991 24.9207 49.5489 25.0246 49.5319 25.1297L47.9018 35.3517C47.8826 35.4748 47.7765 35.5652 47.6511 35.5652ZM37.7555 35.0569H47.4342L48.923 25.7194L37.7555 35.0569Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.23 20.4779C83.518 20.4779 86.4585 23.8295 85.7988 27.9651C85.1391 32.1007 81.1289 35.4523 76.8419 35.4523C72.5539 35.4523 69.6134 32.1007 70.2731 27.9651C70.9328 23.8295 74.9419 20.4779 79.23 20.4779ZM79.6457 23.4771C79.7643 22.9812 79.4118 22.5519 78.9046 22.5519C78.882 22.5519 78.8606 22.553 78.838 22.5542C78.3387 22.5869 77.9004 23.0004 77.8575 23.4771L77.1989 30.9733C77.1831 31.1427 77.3017 31.2817 77.4802 31.2941C77.4881 31.2941 77.496 31.2952 77.505 31.2952C77.6925 31.2952 77.8722 31.1552 77.9151 30.9733L79.6457 23.4771ZM77.1729 33.3783C77.6304 33.3783 78.0585 33.0213 78.1286 32.5796C78.1986 32.1379 77.8857 31.781 77.4282 31.781C76.9707 31.781 76.5426 32.1379 76.4725 32.5796C76.4014 33.0202 76.7154 33.3783 77.1729 33.3783Z",
    fill: "#7FA8E7",
    style: {
      fill: "#7FA8E7",
      fill: "color(display-p3 0.4980 0.6588 0.9059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8419 35.7065C74.6583 35.7065 72.7447 34.8739 71.4536 33.3613C70.2042 31.8973 69.6959 29.9668 70.0212 27.9256C70.699 23.6793 74.8289 20.2238 79.23 20.2238C81.4135 20.2238 83.3271 21.0563 84.6183 22.5689C85.8677 24.0329 86.376 25.9634 86.0507 28.0046C85.3729 32.2521 81.2418 35.7065 76.8419 35.7065ZM79.23 20.7321C75.0684 20.7321 71.1633 23.9945 70.5239 28.0058C70.2223 29.8979 70.69 31.6827 71.841 33.0315C73.0328 34.4288 74.8097 35.1981 76.8419 35.1981C81.0035 35.1981 84.9086 31.9358 85.548 27.9244C85.8496 26.0323 85.3819 24.2475 84.2308 22.8987C83.0391 21.5014 81.2622 20.7321 79.23 20.7321ZM77.1729 33.6325C76.8769 33.6325 76.6036 33.5127 76.4251 33.3026C76.2477 33.0948 76.1754 32.8236 76.2206 32.539C76.3076 31.9968 76.7933 31.5675 77.3469 31.5291C77.2384 31.4997 77.1435 31.441 77.0712 31.3563C76.9763 31.2444 76.9312 31.101 76.9458 30.9507L77.6044 23.4556C77.6586 22.8501 78.193 22.3441 78.821 22.3023C78.8481 22.3 78.8764 22.2989 78.9046 22.2989C79.2288 22.2989 79.5248 22.4367 79.7146 22.6784C79.901 22.9157 79.9665 23.2274 79.893 23.5358L78.1613 31.0321C78.0992 31.2941 77.871 31.4986 77.6067 31.5426C77.8315 31.5811 78.0326 31.6906 78.1738 31.8578C78.3511 32.0657 78.4234 32.3368 78.3782 32.6214C78.289 33.1874 77.758 33.6325 77.1729 33.6325ZM77.4271 32.034C77.0961 32.034 76.773 32.3018 76.7222 32.6192C76.7007 32.7547 76.7323 32.8801 76.8114 32.9728C76.895 33.0699 77.0227 33.1241 77.1729 33.1241C77.5039 33.1241 77.827 32.8564 77.8778 32.539C77.8992 32.4034 77.8676 32.278 77.7885 32.1854C77.705 32.0883 77.5762 32.034 77.4271 32.034ZM78.9046 22.8061C78.8888 22.8061 78.873 22.8072 78.856 22.8083C78.4821 22.8332 78.1421 23.1495 78.1105 23.4997L77.4519 30.9959C77.4508 31.0095 77.453 31.0196 77.4587 31.0264C77.4655 31.0343 77.4802 31.04 77.4971 31.0411C77.5739 31.0411 77.6507 30.9812 77.6665 30.9157L79.3983 23.4206C79.3983 23.4195 79.3983 23.4195 79.3983 23.4183C79.4367 23.2602 79.4062 23.1088 79.3158 22.9925C79.222 22.8739 79.0729 22.8061 78.9046 22.8061Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4271 31.7798C77.8846 31.7798 78.1987 32.1367 78.1275 32.5784C78.0564 33.0201 77.6294 33.3771 77.1719 33.3771C76.7144 33.3771 76.4003 33.0201 76.4715 32.5784C76.5427 32.1367 76.9696 31.7798 77.4271 31.7798Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1728 33.4347C76.931 33.4347 76.7187 33.3421 76.5752 33.1738C76.4363 33.0111 76.3798 32.7965 76.4159 32.5706C76.4905 32.104 76.9446 31.7245 77.4269 31.7245C77.6687 31.7245 77.8811 31.8171 78.0245 31.9854C78.1635 32.1481 78.22 32.3627 78.1838 32.5898C78.1092 33.0541 77.6551 33.4347 77.1728 33.4347ZM77.4269 31.8363C76.9966 31.8363 76.5933 32.173 76.5266 32.5875C76.4961 32.7807 76.5436 32.9626 76.6599 33.1004C76.7819 33.2427 76.9627 33.3218 77.1717 33.3218C77.602 33.3218 78.0053 32.9852 78.072 32.5706C78.1025 32.3774 78.055 32.1955 77.9387 32.0577C77.8167 31.9154 77.6359 31.8363 77.4269 31.8363Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9046 22.5519C79.4118 22.5519 79.7642 22.98 79.6456 23.477L77.9139 30.9733C77.871 31.1551 77.6913 31.2952 77.5038 31.2952C77.4959 31.2952 77.488 31.2952 77.479 31.2941C77.3005 31.2817 77.1819 31.1427 77.1977 30.9733L77.8563 23.477C77.8992 23.0003 78.3375 22.588 78.8368 22.5541C78.8605 22.553 78.882 22.5519 78.9046 22.5519Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5038 31.3517C77.4947 31.3517 77.4846 31.3517 77.4755 31.3506C77.3727 31.3438 77.2823 31.2998 77.2213 31.2275C77.1615 31.1574 77.1332 31.0648 77.1423 30.9677L77.8008 23.4714C77.846 22.9699 78.3092 22.5327 78.8333 22.4977C79.1236 22.4762 79.3925 22.5892 79.5586 22.7993C79.7077 22.9891 79.7596 23.2399 79.6998 23.4895L77.968 30.9857C77.9206 31.1947 77.7206 31.3517 77.5038 31.3517ZM78.9045 22.6084C78.8842 22.6084 78.8627 22.6095 78.8412 22.6107C78.3691 22.6423 77.9533 23.0332 77.9138 23.4816L77.2552 30.9778C77.2496 31.0445 77.2677 31.1066 77.3083 31.1541C77.3501 31.2026 77.4123 31.2331 77.4846 31.2377C77.6483 31.2478 77.8223 31.1224 77.8596 30.9609L79.5913 23.4647C79.6433 23.2455 79.6015 23.0343 79.4716 22.8705C79.3394 22.7044 79.1327 22.6084 78.9045 22.6084Z",
    fill: "#EEF3FC",
    style: {
      fill: "#EEF3FC",
      fill: "color(display-p3 0.9333 0.9529 0.9882)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlue);
export default __webpack_public_path__ + "static/media/mailBlue.c1fb260d962de246e371fe6eb8bedff9.svg";
export { ForwardRef as ReactComponent };